export default "__VITE_ASSET__BBD3qkb1__"